import { render, staticRenderFns } from "./message-custom.vue?vue&type=template&id=7dc582b4&scoped=true"
import script from "./message-custom.vue?vue&type=script&lang=ts"
export * from "./message-custom.vue?vue&type=script&lang=ts"
import style0 from "./message-custom.vue?vue&type=style&index=0&id=7dc582b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc582b4",
  null
  
)

export default component.exports